package er.prateek.crossly.data.model

import kotlinx.serialization.Serializable

@Serializable
data class UserProgress(
    val starsByPuzzleId: Map<String, Int> = emptyMap(),
    val dailyStreak: StreakInfo = StreakInfo(),
    /** Stars spent on letter reveals. Subtracted from the sum of [starsByPuzzleId] to get the
     *  spendable balance -- see [er.prateek.crossly.progression.ProgressionManager.starsAvailable]. */
    val starsSpent: Int = 0,
    /** Fastest solve per puzzle, in milliseconds. Missing ids have never been timed. */
    val bestTimeMsByPuzzleId: Map<String, Long> = emptyMap(),
    /**
     * Stars for the newer, leveled game modes (math crossword, riddles), keyed
     * [GameMode.name] -> levelId -> best stars. Kept separate from [starsByPuzzleId] so each mode
     * progresses independently and the crossword path is never touched. Additive + defaulted, so
     * an older build reading this blob simply ignores it (see [er.prateek.crossly.progression.ModeProgressionManager]).
     */
    val modeStarsByLevelId: Map<String, Map<String, Int>> = emptyMap(),
    /** Fastest solve per leveled-mode level, keyed [GameMode.name] -> levelId -> millis. */
    val modeBestTimeMsByLevelId: Map<String, Map<String, Long>> = emptyMap(),
    /**
     * The any-game streak. `null` on installs that predate it -- [er.prateek.crossly.progression.StreakManager]
     * then seeds it once from [dailyStreak] so an existing daily streak carries over.
     */
    val playStreak: PlayStreak? = null,
)
